import styled, { css } from 'styled-components';
import { Box } from 'lmc-ui-library';

export const Header = styled.h2`
  font-family: var(--secondary-font);
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  color: #13171b;
`;

export const ErrorItem = styled.div`
  display: flex;
`;

export const ErrorText = styled.div`
  line-height: 26px;
  font-size: 14px;
  text-align: justify;
  width: 90%;
  margin-left: 10px;
`;

export const CreditHistoryWrapper = styled(Box.Content)<any>`
  ${(p) =>
    p.isLoading &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;
